import InstagramGalleryEntity from "@apps/instagram/entities/InstagramGalleryEntity";
import InstagramGalleryService from "@apps/instagram/services/InstagramGalleryService";
import InstagraGalleryServiceInterface from "@apps/instagram/services/InstagramGalleryService/InstagramGalleryServiceInterface";
import { Observable } from "rxjs";

class InstagramGalleryServiceMainProductPageAdapter
    implements InstagraGalleryServiceInterface
{
    constructor(
        private readonly instagramGalleryService: InstagramGalleryService,
        private readonly galleryId: number
    ) {}

    getGallery(): Observable<InstagramGalleryEntity> {
        return this.instagramGalleryService.getGallery(this.galleryId);
    }
}

export default InstagramGalleryServiceMainProductPageAdapter;
